<template>
  <SanityImage class="SidepaneMixedImage" :asset="value.asset" />
</template>

<script>
export default {
  props: {
    value: Object,
  },
}
</script>
